import { render } from "./UserEditForm.vue?vue&type=template&id=2617bcb3&scoped=true"
import script from "./UserEditForm.vue?vue&type=script&lang=js"
export * from "./UserEditForm.vue?vue&type=script&lang=js"

import "./UserEditForm.vue?vue&type=style&index=0&id=2617bcb3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2617bcb3"

export default script